/**
 * qs-video-player.js entry (PRD §9: one deferred script, no dependencies).
 * Globals: only window.QSVideoPlayer (API) and window.QS_VIDEO_CONFIG (page config), §14.
 */
import { createApp } from './app.js';
import { createBrowserEnv } from './browser-env.js';

(function boot(win) {
  if (win.QSVideoPlayer) return; // loaded twice
  const app = createApp(createBrowserEnv(win));
  win.QSVideoPlayer = app;
  const start = () => {
    app.init().catch((error) => {
      // Never break the page: the slots keep their reserved space.
      if (win.console) win.console.warn('[QSVP] init failed', error);
    });
  };
  if (win.document.readyState === 'loading') win.document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})(window);
